/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is ideal body weight?`)
};

const es_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el peso corporal ideal?`)
};

const de_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das Idealgewicht?`)
};

const nl_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is ideaal lichaamsgewicht?`)
};

const fr_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le poids corporel idéal ?`)
};

const it_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il peso corporeo ideale?`)
};

const pt_br2_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é peso corporal ideal?`)
};

const pt_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o peso corporal ideal?`)
};

const ja_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重とは何ですか?`)
};

const zh_iw_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是理想体重？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_q1", locale)
	if (locale === "en") return en_iw_faq_q1(inputs)
	if (locale === "es") return es_iw_faq_q1(inputs)
	if (locale === "de") return de_iw_faq_q1(inputs)
	if (locale === "nl") return nl_iw_faq_q1(inputs)
	if (locale === "fr") return fr_iw_faq_q1(inputs)
	if (locale === "it") return it_iw_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_q1(inputs)
	if (locale === "pt") return pt_iw_faq_q1(inputs)
	if (locale === "ja") return ja_iw_faq_q1(inputs)
	return zh_iw_faq_q1(inputs)
};